import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './LoginPage.css';
import Button from '../../components/Button';

const VerifyEmail = () => {
  const [status, setStatus] = useState(null);
  const [isAlreadyVerified, setIsAlreadyVerified] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('Invalid verification link.');
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/users/verify-email?token=${token}`);
        const data = await response.json();

        if (response.ok) {
          setStatus(data.message);
          if (data.message === 'Email is already verified.') {
            setIsAlreadyVerified(true);
          }
        } else {
          setStatus(data.message);
        }
      } catch (error) {
        console.error('Error verifying email:', error);
        setStatus('An error occurred while verifying your email.');
      }
    };

    verifyEmail();
  }, [searchParams]);

  const handleContinue = () => {
    navigate('/login');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-form">
          <h2>Email Verification</h2>
          <p className="subtitle">
            {status || 'Verifying your email...'}
          </p>
          <Button type="button" onClick={handleContinue}>
            Go to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
